export const GROUP_NAME = 'badges';
